webpackJsonp([1],{

/***/ "0M5Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "52Ql":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DE+O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E7s+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HthW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JvJv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4a906d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("bp21")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e4cd6ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("52Ql")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16e24576","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WAiT")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-16e24576"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03fd9bce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("E7s+")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-03fd9bce"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd022a4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("uDJ7")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d61b78ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){_vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("JvJv")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3871240a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("0M5Z")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fc5c198","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("x9Sl")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ee1b5e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})})):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("DE+O")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-482838ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("opfQ")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eb99c71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("P1S/")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27efe336","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("u/WO")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-27efe336"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b990a520","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("biBg")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12525ca8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("NXlJ")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e4b9ed4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("HthW")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Environmental, Social and Governance Report",
  "shortTitle": "",
  "description": "",
  "width": 1263,
  "height": 893,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "https://euro2024sustainabilityreport.uefa.com"
  }],
  // "basePath": "/",
  "basePath": "",
  "companyLogo": "1-logo-1.png",
  "publishURL": "https://euro2024sustainabilityreport.uefa.com/static/_thumbs",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/static/_content/euro_2024_esg.pdf',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScaleC 1-logo-1\" style=\"top:-11px; left:3px;\" src=\"/static/_content/1-logo-1.png\" />\n        <img class=\"halfScale 1-title\" style=\"top:346px;left:54px\" src=\"/static/_content/1-title-1.png\" />\n        <img class=\"halfScale 1-title\" style=\"top:582px;left:56px\" src=\"/static/_content/1-title-2.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(cOf(\"1-logo-1\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n            .staggerFromTo(cOf(\"1-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0}, 0.3, 1.2)\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n        }\n      ",
    "searchText": "ENVIRONMENTAL, SOCIAL AND GOVERNANCE REPORT Post-event assessment"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top: 240px;left: 40px;width: 210px;height: 79px;\" onclick=\"Publish.goToPage(3)\"></div>\n        <div class=\"addContentLink\" style=\"top: 390px;left: 40px;width: 210px;height: 79px;\" onclick=\"Publish.goToPage(5)\"></div>\n\n        <div class=\"addContentLink\" style=\"top: 186px;left: 252px;width: 282px;height: 48px;\" onclick=\"Publish.goToPage(6)\"></div>\n        <div class=\"addContentLink\" style=\"top: 240px;left: 312px;width: 222px;height: 169px;\" onclick=\"Publish.goToPage(7)\"></div>\n        <div class=\"addContentLink\" style=\"top: 430px;left: 312px;width: 222px;height: 129px;\" onclick=\"Publish.goToPage(15)\"></div>\n        <div class=\"addContentLink\" style=\"top: 583px;left: 312px;width: 222px;height: 135px;\" onclick=\"Publish.goToPage(18)\"></div>\n\n        <div class=\"addContentLink\" style=\"top: 186px;left: 568px;width: 282px;height: 48px;\" onclick=\"Publish.goToPage(21)\"></div>\n        <div class=\"addContentLink\" style=\"top: 240px;left: 626px;width: 222px;height: 169px;\" onclick=\"Publish.goToPage(22)\"></div>\n        <div class=\"addContentLink\" style=\"top: 430px;left: 626px;width: 222px;height: 129px;\" onclick=\"Publish.goToPage(26)\"></div>\n        <div class=\"addContentLink\" style=\"top: 583px;left: 626px;width: 222px;height: 135px;\" onclick=\"Publish.goToPage(32)\"></div>\n        <div class=\"addContentLink\" style=\"top: 741px;left: 626px;width: 222px;height: 108px;\" onclick=\"Publish.goToPage(34)\"></div>\n\n        <div class=\"addContentLink\" style=\"top: 186px;left: 881px;width: 282px;height: 48px;\" onclick=\"Publish.goToPage(35)\"></div>\n        <div class=\"addContentLink\" style=\"top: 240px;left: 938px;width: 251px;height: 189px;\" onclick=\"Publish.goToPage(36)\"></div>\n        <div class=\"addContentLink\" style=\"top: 447px;left: 938px;width: 222px;height: 111px;\" onclick=\"Publish.goToPage(43)\"></div>\n        <div class=\"addContentLink\" style=\"top: 583px;left: 938px;width: 242px;height: 135px;\" onclick=\"Publish.goToPage(44)\"></div>\n        <div class=\"addContentLink\" style=\"top: 741px;left: 938px;width: 222px;height: 108px;\" onclick=\"Publish.goToPage(47)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function() {\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n        removeContentLinks();\n        }\n      ",
    "searchText": "EURO 2024 ESG REPORT  TABLE OF CONTENTS OUR AREAS OF ENVIRONMENTAL ACTION  06  OUR AREAS OF SOCIAL ACTION  21  OUR AREAS OF GOVERNANCE ACTION  03  07  22  36  INTRODUCTION  CLIMATE ACTION  RIGHTS PROTECTION  GOOD GOVERNANCE  15  26  SUSTAINABLE INFRASTRUCTURE  DIVERSITY AND INCLUSION  05 EURO 2024 IN NUMBERS  Smart mobility In focus – A smart move Carbon management In focus – Preparing for reduction Advocacy In focus – Investing in climate resilience  Energy Water  Anti-discrimination Children and youth Reporting and remedy mechanism In focus – A  safe and accessible reporting system  Accessibility Workforce equality Advocacy In focus – Access for all  Risk management In focus – U  pholding and protecting human rights Procurement Transparency In focus – A  multi-stakeholder approach Accountability In focus – Evaluation by a third party  43 EDUCATION  Training Knowledge sharing  18  32  44  CIRCULAR ECONOMY  HEALTH AND WELL-BEING  COMMUNICATIONS  34  47  SOLIDARITY  ECONOMY  4R principle Waste management In focus – Application of the 4Rs  Non-smoking policy Healthy food and beverages Promotion of exercise  Grassroots sports and society Charity and philanthropy  35  Campaigns Communications In focus – Promoting ESG at EURO 2024  Reporting Event impact"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "EURO 2024 ESG REPORT  INTRODUCTION EURO 2024: MORE THAN JUST FOOTBALL By Michele Uva, UEFA Director of Social and Environmental Sustainability As Spain lifted the UEFA EURO 2024 trophy, they closed a tournament that went beyond incredible gameplay and memorable on-field moments. It was a celebration of football’s impact on society, setting new records and sparking change that extends far beyond the pitch. UEFA EURO 2024 wasn’t just a sports event; it was a global movement. Over 2.67 million fans filled ten stadiums across Europe, while 5.4 billion viewers tuned in worldwide. Fan zones in host cities welcomed millions, creating an unmatched energy and connection with fans everywhere. But our ambition was more than numbers. This tournament’s heartbeat was its drive for sustainability, inclusion, and integrity, woven deeply into its core. Guided by three principles—ambition, action, and accountability—EURO 2024 proved how football can lead by example. Ambition in terms of being determined to consider environmental, social and governance (ESG) as a driving force and part of the tournament’s DNA. Action in terms of acknowledging that credibility on this agenda requires putting in place concrete and measurable activities.  Accountability in terms of embracing transparent, responsible and accountable practices throughout all operations, well aware of our responsibility toward the passion of billions of fans for this unique event. These three principles pushed us to consider environmental, social, and governance values as essential. It has been a fascinating journey in which we overcame initial obstacles and skepticism, but as time progressed, we noticed how across the planning, execution, and reporting phases, we have opened a path toward a new, modern way of shaping a sport event. This vision became reality through targeted efforts and the dedication of the UEFA, EURO 2024 GmbH and DFB teams. Thanks to the work of 17 dedicated managers and over 500 volunteers, we embedded sustainability through 150 performance measures and a €29.6 million investment. On the environmental front, we implemented 50 integrated actions. We reduced the tournament’s carbon footprint by providing several public transport options for fans and workforce, adopting green initiatives across all 10 venues, minimising the participating teams impact, moving away from offsetting and investing in value chain mitigation, creating a dedicated Climate Fund that supported grassroots climate projects across Germany."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "On the social front, we made inclusion non-negotiable. Enhanced stadium services allowed over 10,000 disabled fans to feel the energy of live matches, and with 46 targeted actions, we protected the rights, safety, and dignity of all fans, players, and staff. Match observers and rapid response teams tackled discrimination on the ground, while our online abuse program actioned 91% of harmful posts, creating safer digital spaces. Our governance strategy focused on transparency and accountability with 30 dedicated actions implemented. We conducted a human rights risk analysis, signed and published a human rights declaration and sustainability criteria were embedded in procurement regulations. We engaged with stakeholders across all levels, including sponsors, host cities and our workforce. This collaboration resulted in hundreds of sustainability actions across the ten host cities and 95% of the targets set pre-tournament achieved, with each city contributing to the overall impact. EURO 2024 underwent an external verification process for sustainability performance, led by DEKRA, in which it achieved the highest possible rating across 53 ESG criteria, including carbon emissions and inclusivity metrics. We amplified our message with communication campaigns. The #FootbALL social campaign was showcased through a dedicated TV commercial, while the 4R principle, advocating the importance to reduce, reuse, recycle and recover, was displaced across LED boardings in stadiums, social media and online platforms, reaching an audience of billions. The ESG Report captures our journey and lessons learned. UEFA EURO 2024 isn’t the finish line; it’s the beginning of a new way forward. Our commitment to ambition, action, and accountability has reshaped what’s possible when football leads with purpose, inspiring a legacy that’s “more than just football”.  HOW TO READ THIS REPORT  This UEFA EURO 2024 Environmental, Social and Governance (ESG) Report focuses on the three key pillars: ENVIRONMENTAL  SOCIAL  GOVERNANCE  Additionally, focus sections are included for readers interested in a deeper dive into our key actions.  For each strategy target we describe: WHAT WE DID ACTIONS WHAT WE ACHIEVED KPI’s  +  FOCUS AREAS"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"abs halfScale 5-title-1\" style=\"top:53px;left:143px;\" src=\"/static/_content/5-title-1.png\"/>\n      <img class=\"abs halfScale 5-title-2\" style=\"top:104px;left:143px;\" src=\"/static/_content/5-title-2.png\"/>\n\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:225px;left:77px; font-size: 2.3em; font-weight: 200; color: #153ddd; padding: 0px; margin: 0px;\"  data-number='{\"to\": 29.6, \"decimals\" : 1, \"preppend\":\"\u20AC\", \"append\":\"m\"}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:225px;left:302px; font-size: 2.3em; font-weight: 200; color: #153ddd; padding: 0px; margin: 0px;\"  data-number='{\"to\": 95, \"append\":\"%\"}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:363px;left:107px; font-size: 2.3em; font-weight: 200; color: #153ddd; padding: 0px; margin: 0px;\"  data-number='{\"to\": 120, \"append\":\"+\"}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:363px;left:297px; font-size: 2.3em; font-weight: 200; color: #153ddd; padding: 0px; margin: 0px;\"  data-number='{\"to\": 500, \"append\":\"+\"}' ></h1>\n\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:177px;left:695px; font-size: 2.3em; font-weight: 200; color: #ffcb00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 10000, \"comma\": true}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:177px;left:897px; font-size: 2.3em; font-weight: 200; color: #ffcb00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 100, \"append\":\"%\"}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:177px;left:1079px; font-size: 2.3em; font-weight: 200; color: #ffcb00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 5.4, \"decimals\": 1, \"append\":\"bn\"}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:321px;left:707px; font-size: 2.3em; font-weight: 200; color: #ffcb00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 100, \"append\":\"%\"}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:321px;left:917px; font-size: 2.3em; font-weight: 200; color: #ffcb00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 124}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:321px;left:1078px; font-size: 2.3em; font-weight: 200; color: #ffcb00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 100, \"append\":\"%\"}' ></h1>\n\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:594px;left:108px; font-size: 2.3em; font-weight: 200; color: #ffcb00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 7, \"preppend\":\"\u20AC\", \"append\":\"m\"}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:594px;left:306px; font-size: 2.3em; font-weight: 200; color: #ffcb00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 81, \"append\":\"%\"}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:594px;left:484px; font-size: 2.3em; font-weight: 200; color: #ffcb00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 75, \"append\":\"%\"}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:594px;left:667px; font-size: 2.3em; font-weight: 200; color: #ffcb00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 4.8, \"decimals\": 1, \"append\":\"m\"}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:752px;left:124px; font-size: 2.3em; font-weight: 200; color: #ffcb00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 50}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:753px;left:291px; font-size: 2.3em; font-weight: 200; color: #ffcb00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 100, \"append\":\"%\"}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:752px;left:483px; font-size: 2.3em; font-weight: 200; color: #ffcb00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 36, \"append\":\"%\"}' ></h1>\n\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:594px;left:898px; font-size: 2.3em; font-weight: 200; color: #153ddd; padding: 0px; margin: 0px;\"  data-number='{\"to\": 17}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:594px;left:1106px; font-size: 2.3em; font-weight: 200; color: #153ddd; padding: 0px; margin: 0px;\"  data-number='{\"to\": 53}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:776px;left:906px; font-size: 2.3em; font-weight: 200; color: #153ddd; padding: 0px; margin: 0px;\"  data-number='{\"to\": 9}' ></h1>\n      <h1 id=\"5-no\" class=\"abs 5-no euro-bold\" style=\"top:753px;left:1091px; font-size: 2.3em; font-weight: 200; color: #153ddd; padding: 0px; margin: 0px;\"  data-number='{\"to\": 81, \"append\":\"%\"}' ></h1>\n\n      <img class=\"abs halfScaleC 5-no-1\" style=\"top:745px;left:655px;\" src=\"/static/_content/5-no-1.png\"/>\n\n\n      ",
    "script": "\n        function onPageEnter() {\n        pg5Anim = new TimelineMax();\n        pg5Anim.fromTo(cOf(\"5-title-1\"), 0.8, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);\n        pg5Anim.fromTo(cOf(\"5-title-2\"), 0.8, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1);\n\n        pg5Anim.fromTo(cOf(\"5-no\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[0])}}, 1)\n          .fromTo(cOf(\"5-no\")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[1])}}, 1.2)\n          .fromTo(cOf(\"5-no\")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[2])}}, 1.3)\n          .fromTo(cOf(\"5-no\")[3], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[3])}}, 1.4)\n          .fromTo(cOf(\"5-no\")[4], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[4])}}, 1.5)\n          .fromTo(cOf(\"5-no\")[5], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[5])}}, 1.6)\n          .fromTo(cOf(\"5-no\")[6], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[6])}}, 1.7)\n          .fromTo(cOf(\"5-no\")[7], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[7])}}, 1.8)\n          .fromTo(cOf(\"5-no\")[8], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[8])}}, 1.9)\n          .fromTo(cOf(\"5-no\")[9], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[9])}}, 2)\n          .fromTo(cOf(\"5-no\")[10], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[10])}}, 2.1)\n          .fromTo(cOf(\"5-no\")[11], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[11])}}, 2.2)\n          .fromTo(cOf(\"5-no\")[12], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[12])}}, 2.3)\n          .fromTo(cOf(\"5-no\")[13], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[13])}}, 2.4)\n          .fromTo(cOf(\"5-no\")[14], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[14])}}, 2.5)\n          .fromTo(cOf(\"5-no\")[15], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[15])}}, 2.6)\n          .fromTo(cOf(\"5-no\")[16], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[16])}}, 2.7)\n          .fromTo(cOf(\"5-no\")[17], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[17])}}, 3.6)\n          .fromTo(cOf(\"5-no\")[18], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[18])}}, 3.7)\n          .fromTo(cOf(\"5-no\")[19], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[19])}}, 3.8)\n          .fromTo(cOf(\"5-no\")[20], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"5-no\")[20])}}, 3.9)\n\n          pg5Anim.fromTo(cOf(\"5-no-1\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 3.5);\n        }\n\n\n        function onPageLeave() {\n        pg5Anim.stop();\n        resetNumbers(\"5-no\");\n        }\n      ",
    "searchText": "EURO 2024 IN NUMBERS  Social  10,000  €29.6m budget for sustainability  120+  sustainability actions were completed  disabled fans were able to attend matches  95%  100%  of matches assessed for human rights risks  of pre-tournament targets achieved  100%  of matches covered with audio-descriptive commentary (ADC)  500+ sustainability volunteers  124  nationalities represented by EURO 2024 volunteers  Environmental  €7m  climate fund supported 272 projects for 190 amateur clubs and 21 regional associations  50  carbon footprint reduction measures implemented  5.4bn  people reached through the #FootbALL campaign  100%  of stadiums had dedicated walking routes and cycling paths  Governance  81%  of match ticket holders used free local public transport  100%  of stadiums operated with renewable energy  75%  reduction of PNAs flights compared with EURO 2016  36%  waste reduction compared with EURO 2016  4.8m  drinks served in reusable cups avoiding single-use plastic  0%  waste to landfill  17  sustainability managers in total  9  sponsors engaged in tournament sustainability activities  53  sustainability criteria audited by third party evaluation  81%  of staff and volunteers completed sustainability e-learning module UEFA EURO 2024 ESG Report  5"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 6-line-1\" style=\"top:186px;left:-204px\" src=\"/static/_content/6-line-1.png\" />\n        <img class=\"halfScale 6-line-2\" style=\"top:186px;left:372px\" src=\"/static/_content/6-line-2.png\" />\n\n        <img class=\"halfScale 6-title-1\" style=\"top:178px;left:97px\" src=\"/static/_content/6-title-1.png\" />\n        <img class=\"halfScale 6-text-1\" style=\"top:295px;left:97px\" src=\"/static/_content/6-text-1.png\" />\n\n        <img class=\"halfScaleC 6-img-1\" style=\"top:462px; left:294px;\" src=\"/static/_content/6-img-1.png\" />\n\n        <img class=\"halfScale 6-title\" style=\"top:92px;left:678px\" src=\"/static/_content/6-title-2.png\" />\n        <img class=\"halfScale 6-title\" style=\"top:92px;left:856px\" src=\"/static/_content/6-title-3.png\" />\n        <img class=\"halfScale 6-title\" style=\"top:92px;left:1104px\" src=\"/static/_content/6-title-4.png\" />\n\n        <img class=\"halfScaleC 6-icon\" style=\"top:98px; left:627px;\" src=\"/static/_content/6-icon-1-1.png\" />\n        <img class=\"halfScaleC 6-icon\" style=\"top:98px; left:844px;\" src=\"/static/_content/6-icon-1-2.png\" />\n        <img class=\"halfScaleC 6-icon\" style=\"top:98px; left:1059px;\" src=\"/static/_content/6-icon-1-3.png\" />\n\n        <img class=\"halfScale 6-img\" style=\"top:236px;left:648px\" src=\"/static/_content/6-img-1-1.png\" />\n        <img class=\"halfScale 6-img\" style=\"top:236px;left:864px\" src=\"/static/_content/6-img-1-2.png\" />\n        <img class=\"halfScale 6-img\" style=\"top:236px;left:1080px\" src=\"/static/_content/6-img-1-3.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim.fromTo(cOf(\"6-line-1\"), 0.4, {opacity:0, x:-60}, {opacity:1, x:0}, 1)\n            .fromTo(cOf(\"6-line-2\"), 0.4, {opacity:0, x:60}, {opacity:1, x:0}, 1.2)\n            .fromTo(cOf(\"6-title-1\"), 0.6, {opacity:0, y:50}, {opacity:1, y:0}, 1.4)\n            .fromTo(cOf(\"6-text-1\"), 0.6, {opacity:0, y:50}, {opacity:1, y:0}, 1.6)\n            .fromTo(cOf(\"6-img-1\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.8)\n            .staggerFromTo(cOf(\"6-title\"), 0.4, {opacity:0, y:-20}, {opacity:1, y:0}, 0.1, 1.4)\n            .staggerFromTo(cOf(\"6-icon\"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.6)\n            .staggerFromTo(cOf(\"6-img\"), 0.4, {opacity:0, y:40}, {opacity:1, y:0}, 0.1, 1.8)\n        }\n\n        function onPageLeave() {\n          pg6Anim.stop();\n        }\n      ",
    "searchText": "CLIMATE ACTION  SUSTAINABLE INFRASTRUCTURE  CIRCULAR ECONOMY  Smart mobility  Energy  4R principle  OUR AREAS OF ENVIRONMENTAL ACTION The ambition was to deliver the UEFA European Football Championship, third largest sporting event in the world, while respecting the highest sustainability standards. Environmental aspects were therefore one of the core priorities during the organisation of the event. Acknowledging the significant footprint of hosting a global event, we made targeted investments to reduce our impact on the environment as much as possible. This chapter details our measures and results relating to climate action, sustainable infrastructure and a circular economy.  Carbon management  Environmental investment  €27,676,370 Advocacy  Water  Waste management"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "CLIMATE ACTION  SMART MOBILITY  Reduce spectators’ carbon impact  WHAT WE ACHIEVED  81%  WHAT WE DID  ACTIONS  Every fan received a public transport pass included with their match ticket, allowing travel to and from the game and around the city at no extra costs. Discounted train tickets to travel between venues were also available. In addition, fans travelling to Germany by train from other countries could get a discounted InterRail passes for round-trips from 32 European nations.  Free public transport for 36 hours for ticket holders  Discounted train passes to travel between venues Discounted international InterRail passes  of match ticket holders used free local public transport  7,600  ticket holders purchased EURO 2024 InterRail tickets  150,000  fewer parking spaces were available compared to domestic matches  275k  ticket holders purchased train tickets to travel between venues Fewer than  5%  of spectators travelled to EURO 2024 venues in their own car  Reduced stadium parking  UEFA EURO 2024 ESG Report  7"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "CLIMATE ACTION  SMART MOBILITY  Reduce organisers’ carbon impact  90%  WHAT WE DID  ACTIONS  A EURO 2024 staff travel policy was created to encourage the workforce to use of smart mobility solutions. Within Germany, the policy included free public transport within the host city and promoted travel by train or in electric vehicles rather than by plane. The impact of flights was also reduced thanks to the use of sustainable aviation fuel (SAF).  Smart travel policy promoted  UEFA created regional clusters for the group stage match schedule to reduce the PNAs’ travel footprint. At the same time, we fostered a collaborative, action-oriented approach, asking PNAs to travel by train or coach within Germany instead of flying. Low-emission fleets of cars, buses and vans were all made available.  ACTIONS  tCO2e reduction thanks to sustainable aviation fuel  100%  of accredited people had free public transport in host city  WHAT WE ACHIEVED  75%  WHAT WE DID  PNAs required to travel by coach, train or flights using SAF  of EURO 2024 staff travelled by public transport within Germany  1,062  Use of sustainable aviation fuel for flights  Reduce teams’ carbon impact  Adapted match schedules  WHAT WE ACHIEVED  Lowemission fleets  reduction in the number of flights compared to EURO 2016  53%  of PNAs travelled by bus  10%  of PNAs travelled by train  Emission reduction plan officially communicated to all PNAs 8"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "CLIMATE ACTION  SMART MOBILITY  Reduce guests’ carbon impact  100%  WHAT WE DID  ACTIONS  Through our transport provision for guests, we showed that comfort and sustainability are not mutually exclusive. We provided a low-emissions event fleet, venue-to-venue transportation by train and group transportation. Low-emissions transport  Venue-to-venue group transportation  Shared transport service in host cities  Trigger good practices in host cities WHAT WE DID  ACTIONS  We worked closely with our host cities to implement smart mobility initiatives, encouraging the use of public transport to visit fan zones. The host cities also introduced more sustainable travel options for travel to the venues, such as free bike rentals and expanded bicycle parking facilities. Smart mobility activities  WHAT WE ACHIEVED  Public transport promotion  Expanded bicycle parking  of guests were informed about shared transport opportunities  95%  of guests shared their transport  100%  of host cities undertook smart mobility activities, including:  58%  of guests used the low-emissions fleet  • Expanding the public transport network • Creating new cycle paths • Promoting footpaths • Making more bicycle parking facilities available  WHAT WE ACHIEVED  100%  of host cities undertook smart mobility activities, including expanding the public transport network, creating new cycle paths, promoting footpaths and making more bicycle parking facilities available  UEFA EURO 2024 ESG Report  9"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IN FOCUS A SMART MOVE  • Discounted national rail tickets  • Discounted InterRail passes Expanded bicycle parking  Making smart mobility accessible Travel posed a significant carbon footprint risk for the tournament, so we offered sustainable options to ticket holders, staff, PNAs and guests. To encourage public and active transport, we made sure these choices were accessible, safe, cost effective and enjoyable. Each EURO 2024 match ticket included a 36-hour local public transport pass for free city travel. We also promoted train travel by offering fans discounted Deutsche Bahn fares for trains within Germany (€29.90 for second class and €39.90 for first class) and 25% off InterRail passes for travel from 32 European nations.  Low emissions event fleets  We discouraged the use of cars by advising fans that carpooling would reduce congestion and save them money and by highlighting that parking would be limited and had to be booked in advance. Fans were encouraged to walk, cycle or use public transport instead. We supported smart mobility with low-emission event fleets and venue-to-venue train transportation, demonstrating that comfort and sustainability can coexist. For team travel, UEFA advised PNAs to choose sustainable modes of transport. When flying was necessary, maximising plane occupancy and using SAF were recommended to reduce carbon emissions by up to 80%. Within Germany, PNAs were encouraged to use trains or buses instead of flying. UEFA’s partnership with Deutsche Bahn included administrative and financial support, including help with booking and prices for private train wagons. For guests, VIPs and commercial partners, optimising vehicle occupancy and using e-mobility solutions were encouraged.  Guests sharing their transport  Regional group stage cuts travel for teams After the draw, UEFA, the German Football Association (DFB) and DFB-Reisebüro GmbH provided national PNAs with a facilities catalogue to ensure the proximity of hotels, training sites and venues, thereby minimising travel.  • North-east (Berlin, Hamburg, Leipzig) • West -central(Dortmund, Düsseldorf, Frankfurt, Gelsenkirchen, Cologne) • South-central (Frankfurt, Munich, Stuttgart)  Sustainability was a new criterion of the group stage match schedule, leading to the creation of three venue clusters:  Matches were scheduled across two clusters per group to reduce travel.  As a result of these measures, group stage air travel was reduced by 75% compared to previous tournament.  36-hour local public transport pass with match ticket  UEFA EURO 2024 ESG Report 10"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "CLIMATE ACTION  CARBON MANAGEMENT 4% Logistics  Measure event’s carbon footprint  ACTIONS  We calculated the tournament’s carbon emissions, focusing on football-material areas such as mobility, purchased goods and services, facilities and logistics. The assessment was carried out using the UEFA Carbon Footprint Calculator, based on the GHG protocol. The assessment is being independently verified to ensure its accuracy and completeness. Measurement of the tournament’s carbon footprint  WHAT WE ACHIEVED EURO 2024 operations carbon footprint :  WHAT WE DID  Product carbon footprint of EURO2024 mascot Albärt calculated by Alicloud  Verification of carbon impact by a third party  70,000  63% Mobility 26% Goods & Services  ACTIONS  Before the tournament, we developed a carbon footprint reduction plan, with a strong emphasis on travel as it had been identified as a key area. The smart mobility activities outlined above were central to this reduction plan. The fact that no new stadiums were built for the tournament helped to drastically reduce the footprint compared to previous tournaments. Travel-focused reduction plan  Reduction measures focused on renewable energy  Reduction through use of Biochar and SAF  5% PNAs  tonnes of CO2e(*)  5% Organiser  (*) assurance process ongoing  Carbon footprint of ticket holder travel :  4% Guests  250,000  83% Others accredited  tonnes of CO2e(*)  Focus on Mobility  3% Volunteers  (*) assurance process ongoing  WHAT WE ACHIEVED  Reduce event’s carbon footprint WHAT WE DID  6% Venue  10%  24%  reduction in the operations carbon footprint  reduction in the carbon footprint of ticket holder travel  50  reduction measures were implemented UEFA EURO 2024 ESG Report  11"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IN FOCUS  ACHIEVING REDUCTION  In 2022, UEFA updated this assessment to include more accurate data and a broader scope, including logistics. The assessment identified four areas of impact: mobility (travel and accommodation), venue (energy, water and waste), goods and services, and logistics. It covered both direct and indirect emissions within the organisers’ control and influence. Travel and transport were originally projected to account for around 80% of UEFA EURO 2024’s emissions. Based on the refined forecast , 50 initiatives were implemented, leading to a reduction in the tournament’s carbon footprint of 10% and in the carbon footprint of ticket holder travel compared with the initial forecast. Notably, the purchase of SAF was among the most impactful reduction measures.  Mobility  REDUCTION INITIATIVES  To effectively measure and reduce carbon emissions, the German government commissioned the Öko-Institut, a leading independent sustainability research organisation, to conduct a feasibility study and forecast the tournament’s carbon footprint.  14  27 Facility  6 Goods and services  Logistics  250,000 (*) Ticket holders travel footprint (*) Assurance process ongoing  REDUCTION RESULTS  320,000  3%  1% Initiative number  70,000 (*) EURO 2024 Footprint [tCO2e]  49%  3  Finally, the fact that only existing infrastructure was used and leveraged – avoiding new constructions - allowed to drastically limit the tournament carbon footprint compared to previous tournaments.  EURO 2024 operations footprint  48%  Operations footprint  78,000  -10%  Forecast  Ticket holders travel footprint  % reduction impact  70,000 Final results  -24%(*)  Forecast  330,000 250,000  Final results  UEFA EURO 2024 ESG Report 10 12"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "CLIMATE ACTION  ADVOCACY  Establish Climate fund  WHAT WE ACHIEVED  WHAT WE DID  ACTIONS  Instead of investing money in traditional schemes to offset the tournament’s unavoidable emissions, we established a climate fund of €7m to help grassroots clubs across Germany develop climate action projects in the areas of smart mobility, energy, water and waste management.  climate mitigation projects were financed  Raise awareness and advocate for action We promoted all our climate action initiatives to key stakeholders of the tournament through media activities such as press conferences, briefings and articles. We spread the word about the importance of preventing waste and maximising product life cycles with the 4R (reduce, reuse, recycle, recover) campaign.  ACTIONS  190  154  amateur clubs benefitted  in energy, 18 in water, 9 in smart mobility, 9 in waste management  21  5,586  regional associations benefitted from the fund  German amateur clubs applied for funding  WHAT WE ACHIEVED  WHAT WE DID  4R campaign raising awareness about natural resources usage  tonnes of carbon emissions were avoided through Climate fund projects  272  Investment in grassroots football infrastructure to mitigate emissions  Promotion and media activities  60,000  Displays on LED screens  5.4bn  people reached through our LED board campaign All stakeholders were affected positively UEFA EURO 2024 ESG Report 13"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IN FOCUS  INVESTING IN CLIMATE RESILIENCE Moving away from offsetting the tournament’s unavoidable emissions through traditional carbon credits, we took responsibility by investing in our sport and the host nation via the UEFA climate fund.  190  amateur clubs benefitted  272  21  climate mitigation projects financed  regional associations benefitted  UEFA distributed €4.9m to 190 sustainable infrastructure projects over three waves of investment and an additional €100,000 to each of Germany’s 21 regional associations, totalling just over €7m. Since early 2024, grassroots clubs in Germany have been able to request financial support for climate protection projects. 5,586 amateur clubs applied for funding in the three waves. Clubs could request up to €250,000 per project, contributing 10% of the total costs, capped at €5,000.  €28,500 60,000  These infrastructure projects are expected to reduce carbon emissions by roughly 60,000 tonnes over the life cycle, equivalent to the electricity use of over 11,000 homes for one year or emissions from over 14,000 gasoline-powered vehicles.  German amateur clubs applied for funding  tonnes of carbon emissions reduction expected over the life cycle  Most projects focused on carbon reduction through energy efficiency or renewable energy use. Over 100 projects requested support for the installation of photovoltaic panels, 67 for battery storage systems and 35 for LED floodlights. The fund’s supervisory committee was composed of Martin Kallen (chief executive of UEFA Events SA), Juliane Seifert (state secretary of the German Ministry of the Interior and Community), Heike Ullrich (DFB general secretary), Michele Uva (UEFA social and environmental sustainability director) and Lindita Xhaferi-Salihu (business engagement lead, UN Climate Change – UNFCCC). A technical committee also evaluated the applications from a technical perspective.  5,586  average project cost  Over  100 photovoltaic solar-panel systems Support requested for  67  battery-storage systems  35  LED floodlights UEFA EURO 2024 ESG Report 14"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Reduce venues’ electricity consumption  ACTIONS  We reviewed power usage and implemented an optimisation plan. We minimised the use of state-of-the-art generators, while using gas-to-liquid (GTL) fuel and eradicating generator usage in the international broadcasting centre (IBC). Floodlight installation  Power optimisation  WHAT WE ACHIEVED  100%  of venues installed LED floodlights  WHAT WE DID  State-ofthe-art generators  Broadcast electricity derived from grid only  673  tCO2e were saved thanks to generators powered by GTL fuel  100%  of power used in the IBC came from the grid  WHAT WE ACHIEVED  Switch to renewable energy WHAT WE DID We planned to run every single match on 100% renewable energy throughout all ten stadiums.  ACTIONS  SUSTAINABLE INFRASTRUCTURE  ENERGY  Renewable energy in stadiums  Renewable energy in the EURO 2024 Frankfurt headquarters  10  All stadiums powered by renewable electricity  100%  renewable electricity was used at EURO 2024 headquarters"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SUSTAINABLE INFRASTRUCTURE  ENERGY  Trigger good practices in host cities WHAT WE DID  ACTIONS  Getting host cities on board was crucial, and we asked them to promote the use of renewable energy. All 18 fan zones used certified green electricity that was generated from renewable sources, thereby minimising CO2 emissions and contributing to climate protection.  Promotion of renewable energy  WHAT WE ACHIEVED  100%  renewable energy powered all 18 fan zones  Minimal use of generators  UEFA EURO 2024 ESG Report 16"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Reduce venues’ water consumption WHAT WE DID  ACTIONS  We used grey water (waste water generated during operations) when possible for irrigation and flushing toilets, thereby saving fresh water. We also optimised the use of water in stadiums and our headquarters.  Optimisation of water consumption  Use of grey water  WHAT WE ACHIEVED  50%  success in implementation Grey water was used during tournament operations  WHAT WE ACHIEVED  Trigger good practices in host cities WHAT WE DID We encouraged the optimisation of water use in fan zones, sharing best practices such as the provision of free drinking water and water-saving toilets.  ACTIONS  SUSTAINABLE INFRASTRUCTURE  WATER  100%  of fan zones provided visitors with free water fountains  Optimisation of water use in fan zones UEFA EURO 2024 ESG Report  17"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "CIRCULAR ECONOMY  4R PRINCIPLE  Produce less waste (reduce)  WHAT WE ACHIEVED  10  WHAT WE DID  ACTIONS  We prioritised packaging-free or limited-packaging products and provided reusable cups to reduce the amount of single-use plastic waste. We implemented a digital ticketing system and digital payment methods and required PNAs to apply circular economy principles at their base camps. Furthermore, we made every effort to order the right quantities of all event materials. Reduced packaging  Reusable cups  Circular economy at team base camps  Digital ticketing system  Maximise product life cycles (reuse) WHAT WE DID  ACTIONS  We implemented a second-life plan for goods, uniforms and materials that were surplus to requirements. We also established a food donation programme across all venues for the entire duration of the tournament, not just matchdays. Right quantities ordered  Second life plans  Donation of leftover food  All stadiums offered reusable cups  10  All stadiums offered digital payment methods  10  All stadiums offered vegetarian and vegan food options  4,789,425 drinks served in reusable cups  WHAT WE ACHIEVED  36%  less waste reduction than EURO 2016  56%  of dressing material upcycled  40  tonnes of food donated  2.7  million digital tickets were issued"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "CIRCULAR ECONOMY  WASTE MANAGEMENT  Optimise waste (recycle)  WHAT WE ACHIEVED  WHAT WE DID  of dressing material reused  ACTIONS  We introduced a comprehensive waste reduction plan, set up recycling stations at all venues and switched to digital business cards. Additionally, volunteers helped educate fans on proper waste disposal practices within the stadium. Waste reduction plans  Recycling points at venues enabling different waste streams to be handled separately  Green volunteers in all venues  28%  100%  100+  9  ‘green volunteers’ were appointed  of benches equipped with recycle bins  separate waste streams were managed in dedicated recycling points for each venue  WHAT WE ACHIEVED  Waste to energy (recover) WHAT WE DID  ACTIONS  We worked to avoid any waste going to landfill and, at the same time, limit as much as possible the amount of material sent for energy recovery by upcycling and recycling branded items like uniforms and gadgets, as well as signage and materials from ceremonies and hospitality tents, such as carpets.  Recovery of waste  0 waste was sent to landfill 47%  of waste material amount purchased was recovered  UEFA EURO 2024 ESG Report 19"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IN FOCUS  APPLICATION OF THE 4R PRINCIPLES Cutting waste thanks to reusable cups Building on the success of reusable cup programmes at recent UEFA events like the 2021 UEFA Champions League final, the focus at EURO 2024 was on minimising waste and extending product lifespans. We collaborated with concessions and stadiums to implement reusable cups across all venues, ensuring that they were reused for each game. As a result, 100% of cold drinks were served in reusable cups, while hot drinks were served in paper cups.  1,434,052 soft drinks ( including water)  3,293,793 beers  ( including shandy and non-alcoholic beer)  61,580 other alcoholic drinks (wines, spirits, etc.)  Turning dressing material into training equipment and kits UEFA partnered with the Lidl Foundation to implement an upcycling initiative. This project, which targeted the collection of polypropylene, PVC and polyester signage materials from all venues, began during the dismantling phase. PNAs facilitated the sorting and collection of these materials into pallets. The goal was to create sustainable training kits from the EURO 2024 dressing materials. Cones and discs were produced from recycled polypropylene, backpacks from PVC, and jerseys from polyester. These kits and equipment were donated to amateur clubs in Germany.  11,525 hot drinks  16%  were nonrecoverable and were incinerated  28%  of materials were reused  RECYCLING EFFORTS AT A GLANCE  56%  (served in paper cups)  were upcycled  40 tonnes of food saved We focused on minimising food waste by closely monitoring daily staff bistro attendance, which revealed that about 40,000 meals were not required. For VIP hospitality, we adjusted food quantities based on the PNAs involved in the match and the time of day, which resulted in 40 fewer tonnes of food being ordered. We also introduced a food donation plan in cooperation with Foodsharing, a German NGO dedicated to reducing food waste. This plan was implemented at most of the 51 matches and for all staff catering. Foodsharing volunteers collected surplus food and distributed it to various entities in the host cities. As a result, 35 tonnes of food were donated instead of going to waste during the tournament.  Zero waste to landfill In line with UEFA’s commitment to send zero waste to landfill, EURO 2024 adhered to strict waste management protocols. All venue waste was sorted at local facilities and recyclable material was diverted to the appropriate streams. 100% of non-recoverable waste was incinerated.  UEFA EURO 2024 ESG Report 20"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 21-line-1\" style=\"top:186px;left:-257px\" src=\"/static/_content/21-line-1.png\" />\n        <img class=\"halfScale 21-line-2\" style=\"top:186px;left:598px\" src=\"/static/_content/21-line-2.png\" />\n\n        <img class=\"halfScale 21-title-1\" style=\"top:174px;left:97px\" src=\"/static/_content/21-title-1.png\" />\n        <img class=\"halfScale 21-text-1\" style=\"top:274px;left:97px\" src=\"/static/_content/21-text-1.png\" />\n\n        <img class=\"halfScaleC 21-img-1\" style=\"top:462px; left:294px;\" src=\"/static/_content/21-img-1.png\" />\n\n        <img class=\"halfScale 21-title\" style=\"top:92px;left:670px\" src=\"/static/_content/21-title-2.png\" />\n        <img class=\"halfScale 21-title\" style=\"top:92px;left:804px\" src=\"/static/_content/21-title-3.png\" />\n        <img class=\"halfScale 21-title\" style=\"top:92px;left:964px\" src=\"/static/_content/21-title-4.png\" />\n        <img class=\"halfScale 21-title\" style=\"top:92px;left:1115px\" src=\"/static/_content/21-title-5.png\" />\n\n        <img class=\"halfScaleC 21-icon\" style=\"top:98px; left:627px;\" src=\"/static/_content/21-icon-1-1.png\" />\n        <img class=\"halfScaleC 21-icon\" style=\"top:98px; left:773px;\" src=\"/static/_content/21-icon-1-2.png\" />\n        <img class=\"halfScaleC 21-icon\" style=\"top:98px; left:922px;\" src=\"/static/_content/21-icon-1-3.png\" />\n        <img class=\"halfScaleC 21-icon\" style=\"top:98px; left:1071px;\" src=\"/static/_content/21-icon-1-4.png\" />\n\n        <img class=\"halfScale 21-img\" style=\"top:236px;left:648px\" src=\"/static/_content/21-img-1-1.png\" />\n        <img class=\"halfScale 21-img\" style=\"top:236px;left:793px\" src=\"/static/_content/21-img-1-2.png\" />\n        <img class=\"halfScale 21-img\" style=\"top:236px;left:942px\" src=\"/static/_content/21-img-1-3.png\" />\n        <img class=\"halfScale 21-img\" style=\"top:236px;left:1091px\" src=\"/static/_content/21-img-1-4.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n          pg21Anim.fromTo(cOf(\"21-line-1\"), 0.4, {opacity:0, x:-60}, {opacity:1, x:0}, 1)\n            .fromTo(cOf(\"21-line-2\"), 0.4, {opacity:0, x:60}, {opacity:1, x:0}, 1.2)\n            .fromTo(cOf(\"21-title-1\"), 0.6, {opacity:0, y:50}, {opacity:1, y:0}, 1.4)\n            .fromTo(cOf(\"21-text-1\"), 0.6, {opacity:0, y:50}, {opacity:1, y:0}, 1.6)\n            .fromTo(cOf(\"21-img-1\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.8)\n            .staggerFromTo(cOf(\"21-title\"), 0.4, {opacity:0, y:-20}, {opacity:1, y:0}, 0.1, 1.4)\n            .staggerFromTo(cOf(\"21-icon\"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.6)\n            .staggerFromTo(cOf(\"21-img\"), 0.4, {opacity:0, y:40}, {opacity:1, y:0}, 0.1, 1.8)\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop();\n        }\n      ",
    "searchText": "RIGHTS PROTECTION  DIVERSITY AND INCLUSION  HEALTH AND WELL-BEING  SOLIDARITY  Antidiscrimination  Accessibility  Non-smoking policy  Grassroots sports and society  Children and youth  Workforce equality  Healthy food and beverage  Charity and philanthropy  Reporting and remedy mechanisms  Advocacy  Promotion of exercise  OUR AREAS OF SOCIAL ACTION UEFA EURO 2024 celebrated people and a shared passion, bringing together individuals of all ages, backgrounds, nationalities and abilities. Our goal was to prevent and fight all forms of discrimination and ensure that the rights of all were protected. The tournament also celebrated diversity and inclusion through its brand identity, promoted health and well-being through football activities across all age groups and fostered solidarity within German and European society by strengthening ties with grassroots football.  Social investment  €1,055,000"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "RIGHTS PROTECTION  ANTI-DISCRIMINATION  Prevent and address discrimination in stadiums WHAT WE ACHIEVED  WHAT WE DID  ACTIONS  We deployed match observers at all matches and applied a three-step procedure to address discriminatory incidents. A grievance mechanism enabled confidential or anonymous reporting in multiple languages. A rapid response system, accessible using a QR code, offered immediate assistance to spectators and safe spaces were available. More than ten volunteers at each venue focused on human rights initiatives.  100%  of matches were assessed for risk, and match observers attended all high risk matches  89  Anti-discrimination match observer scheme Three-step procedure  All referees were retrained in the three-step procedure against discrimination  10  All stadiums offered all-gender toilets  100+  human rights volunteers worked at the tournament  Rapid response mechanism  Grievance mechanism  Safe space available  Human rights volunteers in all venues  10  All stadiums offered culturally diverse food options  214  interactions with the rapid response team and safe spaces were used 56 times throughout the tournament  44  potentially discriminatory cases were identified of which 19 were confirmed, resulting in 19 sanctions being applied  UEFA EURO 2024 ESG Report 22"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "RIGHTS PROTECTION  ANTI-DISCRIMINATION  Monitor, report and remedy cases of online abuse WHAT WE DID  ACTIONS  UEFA developed an online abuse programme to monitor, report and address cases of online abuse during all UEFA finals and tournaments. In collaboration with META, X and TikTok, the programme attempted to raise awareness, monitored social media accounts and initiated remedial action.  Online abuse system in place  Coverage of more languages for monitoring  WHAT WE ACHIEVED  696  25  666  20  individual social media accounts were monitored  languages extended in the monitoring  abusive posts were reported and 91%* actions rate  cases were referred to the authorities  (*) posts were actioned by the platform, meaning that platforms either removed or restricted the visibility  Raise awareness and advocate for action WHAT WE ACHIEVED  WHAT WE DID  ACTIONS  The tournament served as an ideal platform to highlight the harm of discrimination and promote inclusivity through the #FootbALL campaign, which was promoted to fans watching at home through a 30-second television advertisement. LED boards and announcements on the big screens spread the message of unity inside the stadiums. We also hosted disabled football matches in fan zones. #FootbALL campaign  ‘Football for all Abilities’ showcase matches  100m  people on average per match day reached by the #FootbALL campaign  2,000+  disabled people attended football matches in fan zones  93%  of comments fell into the general hate category of abuse"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "RIGHTS PROTECTION  Implement child and youth protection policy  20+  WHAT WE DID  ACTIONS  In line with UEFA’s broader child safeguarding policy, the tournament implemented a dedicated child and youth protection policy. Dedicated safeguarding officers conducted risk assessments and were responsible for reporting and escalating any cases of abuse.  Child and youth protection policy  Human rights volunteers contributing to child safeguarding  Reporting and escalation process  Reporting and remedy mechanisms  human rights volunteers focusing on child safeguarding  10  All venues with child and youth protection policy implemented  270  UEFA established an accessible and independent grievance reporting mechanism open to everyone. Reports could be filed confidentially using a secure online form in any of the participating PNAs’ languages. In addition, the rapid response mechanism available at all venues offered immediate assistance to spectators who felt harassed, discriminated against, threatened or unsafe.  ACTIONS  of venues put in place a reporting and escalation process  WHAT WE ACHIEVED  WHAT WE DID  Grievance mechanisms  100%  WHAT WE ACHIEVED  CHILDREN AND YOUTH AND REPORTING AND REMEDY MECHANISM  Rapid response mechanism  Points of contact  529  cases discriminatory incidents and rights violations were reported  spectators received assistance on-site  10  All venues had points of contact for rights violations designated UEFA EURO 2024 ESG Report 24"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IN FOCUS  Reporting a grievance Ahead of the tournament, we anticipated the potential for human rights issues and established an accessible grievance mechanism.  A SAFE AND ACCESSIBLE REPORTING SYSTEM  Launched internally in December 2023 and open to the public on 1 June 2024, this system was open to anyone who felt their rights were violated during the tournament, including players, spectators, journalists, staff, volunteers, suppliers and service providers. Managed independently by the German law firm Rettenmaier, with technical support from Legaltegrity, reports could be submitted via a secure online form available in all the participating PNAs’ languages. Reports were handled confidentially by trained trauma specialists, and individuals had the option to remain anonymous. The mechanism was free and non-discriminatory, ensuring that everyone was able to report human rights violations.  Immediate assistance In addition to the grievance procedure, a rapid response mechanism was implemented at all EURO 2024 venues to provide immediate assistance to spectators who felt harassed, discriminated against, threatened or unsafe. Dedicated points of contact were available on matchdays to offer prompt help. Information about the mechanism, including a QR code for easy contact, was displayed on posters throughout the stadiums. Each venue also had a safe space for those in need. The system was set up together with SAFER, a project led by Football Supporters Europe and funded by the European Commission. During the tournament, 214 spectators contacted the support team and 56 visited safe spaces for immediate assistance.  Combating online abuse Before the tournament, PNAs, players, coaches and referees were briefed on preventive measures to limit abusive content on their social media accounts. We monitored 696 accounts, and flagged 666 posts for further action. Of these, 31% were removed and 60% had their reach significantly reduced. The monitoring scheme covered 25 languages worldwide and content was flagged in 20 languages. UEFA EURO 2024 ESG Report 25"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "DIVERSITY AND INCLUSION  ACCESSIBILITY WHAT WE ACHIEVED  Ensure stadium accessibility  10 venues had:  • Accessibility information points and sensory bags available  WHAT WE DID We ensured accessibility by conducting audits in cooperation with AccessibALL experts and providing Easy Access seats, adequate wheelchair spaces, accessible toilets, dedicated parking, quality assistance services, a wheelchair loan service and shuttle services at all stadiums. Furthermore, we ran a survey to evaluate the perception of the overall accessibility experience.  ACTIONS  All  Accessibility audits  Wheelchair spaces and services  Accessibility volunteers in all venues  Accessibility services  • Dedicated signage and barrier-free access was provided to help disabled fans enter and move around all venues • All wheelchair spaces offered a barrier-free view of the pitch  100% of venues offered quality assistance services, including the wheelchair push and loan service available at every venue  10,000+  disabled fans bought tickets for wheelchair spaces or Easy Access seats  4,451  accessible parking spaces were made available  • Priority lanes were provided for disabled fans at entrances, exits and concessions  1,000+  79%  250+  of spectators with accessibility needs reported an aboveaverage or excellent experience  spectators used the shuttle and buggy services  accessibility volunteers were appointed for the tournament  26"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "DIVERSITY AND INCLUSION  ACCESSIBILITY  Provide audio-descriptive commentary (ADC)  WHAT WE ACHIEVED  WHAT WE DID  100%  Multi-language options  ADC service  of matches offered ADC  15  languages provided  41,561  unique accesses to the service  Provide accessible tournament information WHAT WE DID  ACTIONS  We ensured that everyone involved in the tournament had access to information essential for them to feel safe and enjoy their experience. This included an e-mail campaign including venue maps and information to ticket holders with limited mobility.  Visible and well-positioned information  The EURO 2024 event guide featured a dedicated accessibility page Sustainability messages were included throughout the EURO 2024 event guide  WHAT WE ACHIEVED  ACTIONS  Audio-descriptive commentary (ADC) was offered at all matches and a remote service was accessible through the official UEFA EURO 2024 app, allowing visually impaired fans anywhere in the world with an internet connection to listen in. Whenever possible, the service was offered in German as well as the languages of the two competing nations. Deutsche Telekom and Vivo supported the project.  UEFA EURO 2024 ESG Report 27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "DIVERSITY AND INCLUSION  ACCESSIBILITY  Offer tickets at an accessible price  WHAT WE ACHIEVED  WHAT WE DID  387,000  ACTIONS  We made sure that fans in various socioeconomic categories had the opportunity to buy tickets and attend matches. This was made possible by selling tickets at affordable prices and allocating a significant number of tickets to the cheapest category. All 51 matches were sold out, with demand exceeding capacity.  Fans First tickets were sold at prices ranging from approximately €30 during the group stage to €60 for the final  Accessible ticket pricing  1,212,000 Fans First and category 3 were sold  825,000 category 3 tickets were sold  UEFA EURO 2024 ESG Report 28"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "DIVERSITY AND INCLUSION  WORKFORCE EQUALITY  AGE  WHAT WE DID  ACTIONS  We ensured a diverse mix of EURO 2024 GmbH staff and volunteers, representing a range of ages, genders and ethnicities to create an inclusive and representative tournament. Inclusivity was also a key focus of the volunteer programme, which featured disabled volunteers working alongside chaperones.  124  Average age: 32,50 years  37  years: average age of volunteers  Staff from 54 nationalities employed Promotion of diversity and inclusion  Tandem option for disabled volunteers  HR rules reinforcing diversity and inclusion  100+  disabled people volunteered at the tournament A human resources dashboard for data collection and management was created  100%  of job postings included a clause on inclusion  nationalities of volunteers  WHAT WE ACHIEVED  Equal access for staff and volunteers"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "DIVERSITY AND INCLUSION  WORKFORCE EQUALITY AND ADVOCACY  Instil values of inclusion and respect among workforce  WHAT WE ACHIEVED  100%  WHAT WE DID  ACTIONS  We embedded diversity and inclusion into our company philosophy and HR policies. Additionally, we actively promoted the grievance and rapid response mechanisms among staff to ensure that any instances of abuse were reported and addressed promptly. Inclusive company philosophy  Role model management  Promotion of grievance and rapid response mechansims  Raise awareness and advocate through brand identity  of recruited staff were trained to advocate for diversity and inclusion Level of awareness of diversity and inclusion among managers increased significantly Human resources dashboard for data collection and management created  Directive on managing conflict and combating harassment was published, made available to all staff and featured in the onboarding presentation from HR EURO 2024 Code of Conduct was published including directives on diversity and inclusion was published  WHAT WE ACHIEVED  WHAT WE DID  ACTIONS  EURO 2024’s brand identity promoted a tournament where everyone was welcome and diversity was celebrated. The brand assets, from the logo, to the patterns and brand video, celebrate the diversity of fans and European football. The tournament logo was derived from the flags of UEFA’s 55 member associations, combining their colours in various ways in the shape of Berlin’s Olympiastadion. The famous Henri Delaunay Trophy features at the centre of the logo, while the 24 coloured slices around it represent the 24 participating teams. Promotion and provision of information  Advocacy through the brand identity and assets  Brand assets, from the logo, to the patterns and brand video, celebrate the diversity of fans and European football  #FootbALL campaign  30"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IN FOCUS  ACCESS FOR ALL The official slogan of UEFA EURO 2024 was ‘United by Football. Vereint im Herzen Europas’ (united in the heart of Europe), and we embodied this spirit by making the tournament as inclusive and accessible as possible. At each venue, we put in place processes to make sure that everyone could have an enjoyable experience, whatever their circumstances. All 10 venues had a dedicated accessibility audit conducted together with AccessibALL and appointed a disability access officer (DAO) and provided accessibility information points. They also each had their own stadium-specific event guide to give travelling fans all the information they needed in one place. Disabled fans or those with limited mobility were offered a number of services to make their experience smooth. In all 10 venues, a team of at least 25 dedicated accessibility volunteers provided best-in-class accessibility support, such as wheelchair push and loan services. Wheelchair users benefited from priority lanes at concession stands, and seats were reserved for spectators who needed assistance dogs. As a result, 79% of spectators with accessibility needs considered  EURO 2024 to be above the average of the best event ever attended. Disability access officers and volunteers All 24 PNAs appointed a dedicated DAO to support the UEFA venue team in liaising with disabled national team supporters. DAO’s provided fans with guidance on optimising the matchday experience, including travel advice, venue services and practical information. They met with UEFA’s venue sustainability managers the day before each match to review accessibility maps, transport, parking provision and seating areas to ensure that they could offer supporters the best advice. Each venue also appointed up to 30 sustainability volunteers, identifiable by bibs featuring an accessibility icon, to assist with accessibility services.  A football first for ADC Audio descriptive commentary (ADC) provides blind and partially sighted fans with detailed descriptions of the match, including the ball’s position, players’ body language and facial expressions. Specially trained commentators deliver all significant visual information to convey the match’s story. Blind and partially sighted supporters worldwide had access to a comprehensive service for all 51 matches at UEFA EURO 2024. While ADC was available in previous UEFA EURO tournaments, this was the first men’s edition to offer a remote service through the official UEFA EURO 2024 app, enabling fans with an internet connection to listen from anywhere. Additionally, it was the first EURO to provide ADC in the languages of the competing teams, as well as the language of the host country.  UEFA EURO 2024 ESG Report 31"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "HEALTH AND WELL-BEING  Reduce consumption of tobacco in the stadium bowl  100%  of stadiums implemented the non-smoking policy  WHAT WE DID  ACTIONS  We established a non-smoking policy in stadiums, informed spectators of the policy through various communication channels and trained stadium staff to enforce it. All volunteers were asked to report any violations.  Non-smoking policy in all stadiums  advisory messages reinforced the policy in each stadium  Advisory messages communicating the policy  Ensuring that healthy food and beverage options are available WHAT WE DID  ACTIONS  We made sure that healthy food and beverage options were available across all EURO 2024 stadiums and venues. The caterers were challenged to provide fresh local and seasonal food for staff and in the hospitality areas, always including vegetarian and vegan options. Working with partners to offer healthy products  100+  Healthy food for staff and guests  Local and seasonal food  Vegetarian and vegan options  WHAT WE ACHIEVED  100%  of stadiums offered a wide range of vegetarian and vegan food options  60%  of food was sourced in Germany  Wide range of vegetarian and vegan food options were available  WHAT WE ACHIEVED  NON-SMOKING POLICY AND HEALTHY FOOD AND BEVERAGE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "HEALTH AND WELL-BEING  PROMOTION OF EXERCISE  Advocate for physical activity and exercise WHAT WE DID  ACTIONS  We encouraged active travel by establishing dedicated walking routes and bicycle parking at stadiums and offering weekly exercise opportunities for staff. Fan zones were connected to the stadiums via walking routes or public transport, with clear signage promoting these options throughout all host cities.  Dedicated walking routes  Ample bicycle parking  WHAT WE ACHIEVED  100%  of stadiums established dedicated walking routes  10  All stadiums offered dedicated bicycle parking  20%  of spectators reached the stadium on foot or by bike  UEFA EURO 2024 ESG Report 33"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOLIDARITY  GRASSROOTS SPORTS AND SOCIETY AND CHARITY AND PHILANTHROPY  Foster ties with and support grassroots football WHAT WE DID  ACTIONS  In collaboration with the DFB, we developed various activations and campaigns to engage grassroots football clubs with EURO 2024. These activities primarily took place in fan zones, which served as a platform to promote the clubs’ initiatives. National climate protection initiative for grassroots football  Support for the DFB’s club campaign  Grassroots sports activities in fan zones  Leverage activities of UEFA Foundation for Children and DFB Foundations  WHAT WE ACHIEVED Matches in fan zones showcasing football for all abilities and dedicated to refugees integration in society  500+  clubs reached from activities in fan zones  WHAT WE ACHIEVED  WHAT WE DID  ACTIONS  We supported the activities of the UEFA Foundation for Children and the DFB Foundation through 10,000 Smiles and other projects. The aim was to offer disadvantaged children the chance to enjoy the tournament atmosphere by donating tickets and funding charity projects through Stiftung Fußball & Kultur EURO 2024 (EURO 2024 football and culture foundation).  10,000 Smiles project  Projects funded by Stiftung Fußball & Kultur EURO 2024  10,000+  free tickets were given to disadvantaged children and young people across the ten host cities  60  individual cultural projects and 11 nationwide projects were funded  UEFA EURO 2024 ESG Report 34"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 35-line-1\" style=\"top:186px;left:-35px\" src=\"/static/_content/35-line-1.png\" />\n        <img class=\"halfScale 35-line-2\" style=\"top:186px;left:370px\" src=\"/static/_content/35-line-2.png\" />\n\n        <img class=\"halfScale 35-title-1\" style=\"top:174px;left:97px\" src=\"/static/_content/35-title-1.png\" />\n        <img class=\"halfScale 35-text-1\" style=\"top:264px;left:97px\" src=\"/static/_content/35-text-1.png\" />\n\n        <img class=\"halfScaleC 35-img-1\" style=\"top:528px; left:294px;\" src=\"/static/_content/35-img-1.png\" />\n\n        <img class=\"halfScale 35-title\" style=\"top:92px;left:647px\" src=\"/static/_content/35-title-2.png\" />\n        <img class=\"halfScale 35-title\" style=\"top:115px;left:810px\" src=\"/static/_content/35-title-3.png\" />\n        <img class=\"halfScale 35-title\" style=\"top:115px;left:942px\" src=\"/static/_content/35-title-4.png\" />\n        <img class=\"halfScale 35-title\" style=\"top:115px;left:1132px\" src=\"/static/_content/35-title-5.png\" />\n\n        <img class=\"halfScaleC 35-icon\" style=\"top:98px; left:618px;\" src=\"/static/_content/35-icon-1-1.png\" />\n        <img class=\"halfScaleC 35-icon\" style=\"top:98px; left:771px;\" src=\"/static/_content/35-icon-1-2.png\" />\n        <img class=\"halfScaleC 35-icon\" style=\"top:98px; left:933px;\" src=\"/static/_content/35-icon-1-3.png\" />\n        <img class=\"halfScaleC 35-icon\" style=\"top:98px; left:1086px;\" src=\"/static/_content/35-icon-1-4.png\" />\n\n        <img class=\"halfScale 35-img\" style=\"top:236px;left:634px\" src=\"/static/_content/35-img-1-1.png\" />\n        <img class=\"halfScale 35-img\" style=\"top:236px;left:785px\" src=\"/static/_content/35-img-1-2.png\" />\n        <img class=\"halfScale 35-img\" style=\"top:236px;left:951px\" src=\"/static/_content/35-img-1-3.png\" />\n        <img class=\"halfScale 35-img\" style=\"top:236px;left:1102px\" src=\"/static/_content/35-img-1-4.png\" />\n      ",
    "script": "\n        function onPageEnter() {\n          pg35Anim = new TimelineMax();\n          pg35Anim.fromTo(cOf(\"35-line-1\"), 0.4, {opacity:0, x:-60}, {opacity:1, x:0}, 1)\n            .fromTo(cOf(\"35-line-2\"), 0.4, {opacity:0, x:60}, {opacity:1, x:0}, 1.2)\n            .fromTo(cOf(\"35-title-1\"), 0.6, {opacity:0, y:50}, {opacity:1, y:0}, 1.4)\n            .fromTo(cOf(\"35-text-1\"), 0.6, {opacity:0, y:50}, {opacity:1, y:0}, 1.6)\n            .fromTo(cOf(\"35-img-1\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.8)\n            .staggerFromTo(cOf(\"35-title\"), 0.4, {opacity:0, y:-20}, {opacity:1, y:0}, 0.1, 1.4)\n            .staggerFromTo(cOf(\"35-icon\"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.6)\n            .staggerFromTo(cOf(\"35-img\"), 0.4, {opacity:0, y:40}, {opacity:1, y:0}, 0.1, 1.8)\n        }\n\n        function onPageLeave() {\n          pg35Anim.stop();\n        }\n      ",
    "searchText": "GOOD GOVERNANCE  EDUCATION  COMMUNICATIONS  ECONOMY  Risk management  Training  Reporting  Event impact  Procurement  Knowledge sharing  Campaigns  OUR AREAS OF GOVERNANCE ACTION We adopted transparent, responsible and accountable forms of conduct in all our operations, including through the presence of dedicated sustainability managers at each venue. We continuously consulted and engaged with relevant stakeholders, including around sustainabilityrelated risks, and particularly on human rights. As part of our good governance ambitions, we organised the tournament in line with international human rights principles, while advocating for and promoting human rights and sustainability through training. We developed sustainability-focused campaigns, reported on our performance against all targets set, and evaluated the tournament’s impact through independent studies.  Transparency  Governance investment  €930,000 Accountability  Communications"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "GOOD GOVERNANCE  RISK MANAGEMENT  Identify risks and formulate mitigating actions WHAT WE DID  ACTIONS  We performed a Human Rights Risk Assessment and published a Human Rights Declaration. Four key commitments were outlined in the declaration: accessibility, diversity and inclusion; no discrimination or abuse; health, safety and well-being; and freedom of speech.  Human Rights Human Rights Risk Assessment Policy  Human Rights Board  WHAT WE ACHIEVED  A Human Rights Risk Assessment was completed in May 2023 following a stakeholders consultation led by Deloitte  The Human Rights Declaration was signed on 14 November 2023  A Human Rights Board was established"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IN FOCUS  UPHOLDING AND PROTECTING HUMAN RIGHTS In November 2023, UEFA and the DFB, together with the German government and host city authorities, presented the Human Rights Declaration for UEFA EURO 2024, showcasing a framework to uphold and protect human rights during the tournament. The declaration was the product of a close cooperation between UEFA, the DFB and the national and local authorities, and it incorporated suggestions from various interest groups, stakeholders and human rights experts such as the Centre for Sport and Human Rights, the Sport and Rights Alliance, the EURO 2024 Stakeholder Initiative and the German Institute for Human Rights.  Five key objectives were outlined in the declaration. Accessibility, diversity and inclusion The tournament organisers committed to making stadiums, work environments and the broader football ecosystem accessible to everyone, to celebrating diversity and inclusion and to encouraging participation from all communities. Additionally, the UEFA Foundation for Children and the DFB Foundation supported football initiatives providing children with access to the games. No discrimination or abuse We made significant efforts to prevent and combat all forms of discrimination and abuse, fostering an environment free from discrimination both at the venues and online. Health, safety and well-being Our goal for UEFA EURO 2024 was to ensure a safe and enjoyable experience for everyone involved. We provided access to healthy food and beverages and actively promoted physical activity.  Freedom of speech UEFA EURO 2024 was an event for everyone, inviting all fans to support their favourite PNAs, celebrate together and exercise their freedom of speech throughout the tournament. Human rights board To further enhance its commitment to human rights, UEFA set up a UEFA EURO 2024 human rights board. The board comprised representatives of NGOs and expert stakeholders, including the Centre for Sport and Human Rights, Transparency International (Germany), Football Supporters Europe, the Sport and Rights Alliance, Reporter Ohne Grenzen, Kick In and the German Institute for Human Rights. The human rights board provided expert guidance on human rights issues related to the tournament; served as a central point of information for all matters related to human rights; facilitated communication and collaboration among stakeholders to share perspectives and shape best practices; and observed and made recommendations on the operational implementation of relevant policies and actions. An independent report to be published in November 2024 will review the Board’s work and provide recommendations for UEFA to further expand on the good practices established for UEFA EURO 2024.  Assessing our potential impact All actions at UEFA EURO 2024 complied with the UN’s internationally recognised Guiding Principles on Business and Human Rights and Germany’s supply chain due diligence act (LkSG). The tournament’s potential human rights impact was assessed in four steps: • First we identified potential human rights risks and groups of rightsholders in the context of UEFA EURO 2024, taking into account the potential negative consequences of our actions throughout the supply and value chains. • Next, we evaluated those rights. • Then we planned measures to mitigate the negative impact, taking into account the different roles of the various actors. • Finally, we described how we intended to address and remedy any potential adverse impact on human rights, how we would monitor our ongoing progress and how we would gauge the effectiveness of those measures in order to update them if necessary.  UEFA EURO 2024 ESG Report 37"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "GOOD GOVERNANCE  PROCUREMENT AND TRANSPARENCY  Adopt a sustainable procurement procedure  WHAT WE ACHIEVED  WHAT WE DID  100%  ACTIONS  We incorporated sustainability criteria into our procurement regulations, prioritising the sourcing of local products and services whenever possible. Additionally, we voluntarily adhered to the principles of Germany’s supply chain due diligence act (LkSG). Sustainability criteria  Local sourcing  Application of Germany’s supply chain due diligence act scheme  Establish transparent management processes  of suppliers were required to sign a Supplier Code as part of the procurement selection criteria  60%  of work force recruited locally  WHAT WE ACHIEVED  WHAT WE DID  ACTIONS  After embedding sustainability in the tournament’s operations, we made all related documentation publicly available. These documents covered all areas of actions and topics included in the tournament’s ESG strategy.  Publication of sustainabilityrelated documentation  www.uefa.com/euro2024/  100%  of EURO 2024 sustainability documents are publicly available on UEFA web platforms  UEFA EURO 2024 ESG Report 38"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "GOOD GOVERNANCE  TRANSPARENCY  WHAT WE DID  ACTIONS  We participated in relevant discussion forums and engaged with sponsors in sustainability activities.  Discussion forums  Sponsors activities  Tournament operations  20  forums were attended where UEFA presented or discussed the EURO 2024 ESG strategy  150+  different stakeholders engaged  9  sponsors collaborated on tournament sustainability activities (Hisense, LIDL, DB, Wiesenhof, Adidas, Coca Cola, Vivo, Alipay, Deutsche Telekom)  WHAT WE ACHIEVED  Ensure involvement of all event stakeholders  88%  of tournament operation projects had sustainability embedded  UEFA EURO 2024 ESG Report 39"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"abs halfScale 40-title\" style=\"top:135px;left:73px;\" src=\"/static/_content/40-title-1.png\"/>\n      <img class=\"abs halfScale 40-title\" style=\"top:236px;left:72px;\" src=\"/static/_content/40-title-2.png\"/>\n      <img class=\"abs halfScale 40-title\" style=\"top:385px;left:72px;\" src=\"/static/_content/40-title-3.png\"/>\n\n      <img class=\"abs halfScaleC 40-circle-no\" style=\"top:790px;left:162px;\" src=\"/static/_content/40-circle-no-1.png\"/>\n      <img class=\"abs halfScaleC 40-circle-no\" style=\"top:670px;left:198px;\" src=\"/static/_content/40-circle-no-2.png\"/>\n      <img class=\"abs halfScaleC 40-circle-no\" style=\"top:552px;left:276px;\" src=\"/static/_content/40-circle-no-3.png\"/>\n      <img class=\"abs halfScaleC 40-circle-no\" style=\"top:470px;left:394px;\" src=\"/static/_content/40-circle-no-4.png\"/>\n      <img class=\"abs halfScaleC 40-circle-no\" style=\"top:417px;left:537px;\" src=\"/static/_content/40-circle-no-5.png\"/>\n      <img class=\"abs halfScaleC 40-circle-no\" style=\"top:417px;left:672px;\" src=\"/static/_content/40-circle-no-6.png\"/>\n      <img class=\"abs halfScaleC 40-circle-no\" style=\"top:460px;left:793px;\" src=\"/static/_content/40-circle-no-7.png\"/>\n      <img class=\"abs halfScaleC 40-circle-no\" style=\"top:549px;left:920px;\" src=\"/static/_content/40-circle-no-8.png\"/>\n      <img class=\"abs halfScaleC 40-circle-no\" style=\"top:661px;left:999px;\" src=\"/static/_content/40-circle-no-9.png\"/>\n      <img class=\"abs halfScaleC 40-circle-no\" style=\"top:784px;left:1034px;\" src=\"/static/_content/40-circle-no-10.png\"/>\n\n\n      <img class=\"abs halfScaleC 40-text\" style=\"top:709px;left:-6px;\" src=\"/static/_content/40-text-1.png\"/>\n      <img class=\"abs halfScaleC 40-text\" style=\"top:600px;left:1px;\" src=\"/static/_content/40-text-2.png\"/>\n      <img class=\"abs halfScaleC 40-text\" style=\"top:481px;left:36px;\" src=\"/static/_content/40-text-3.png\"/>\n        <img class=\"abs halfScaleC 40-text\" style=\"top:406px;left:291px;\" src=\"/static/_content/40-text-4.png\"/>\n      <img class=\"abs halfScaleC 40-text\" style=\"top:330px;left:441px;\" src=\"/static/_content/40-text-5.png\"/>\n      <img class=\"abs halfScaleC 40-text\" style=\"top:337px;left:598px;\" src=\"/static/_content/40-text-6.png\"/>\n       <img class=\"abs halfScaleC 40-text\" style=\"top:433px;left:754px;\" src=\"/static/_content/40-text-7.png\"/>\n      <img class=\"abs halfScaleC 40-text\" style=\"top:525px;left:881px;\" src=\"/static/_content/40-text-8.png\"/>\n      <img class=\"abs halfScaleC 40-text\" style=\"top:592px;left:996px;\" src=\"/static/_content/40-text-9.png\"/>\n      <img class=\"abs halfScaleC 40-text\" style=\"top:685px;left:1030px;\" src=\"/static/_content/40-text-10.png\"/>\n\n\n\n      ",
    "script": "\n        function onPageEnter() {\n        pg40Anim = new TimelineMax();\n        pg40Anim.staggerFromTo(cOf(\"40-title\"), 0.8, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"40-circle-no\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.4)\n          .staggerFromTo(cOf(\"40-text\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.6)\n\n\n        }\n\n        function onPageLeave() {\n        pg40Anim.stop();\n        }\n      ",
    "searchText": "IN FOCUS  A MULTI-STAKEHOLDER APPROACH To leave a genuinely sustainable legacy, we sought input from all key stakeholders before developing and implementing our EURO 2024 ESG Strategy. The collaboration with our 10 host cities resulted in more than 120 sustainability actions for the tournament. Each city showcased its own sustainability highlights, while the German government took additional steps to amplify our impact. All host cities implemented at least ten sustainability activities: Free sun cream:  Visitors received free sun cream to protect against harmful UV rays.  Sustainable and healthy food:  A range of healthy dishes, including vegan and vegetarian options from organic and fair-trade sources, was offered to promote healthy eating and a climate-friendly diet.  3  4  Free drinking water:  Free drinking water was provided to protect against dehydration in the heat to and reduce the number of plastic bottles used.  5  Accessibility:  All fan zones had accessible entrances, viewing platforms and toilets to ensure an inclusive experience.  6  Inclusive football tournaments:  7  Inclusive football tournaments were organised to promote integration and social cohesion through sport.  Awareness and safeguarding:  8  Safety concepts were implemented to prevent and address discrimination, fostering an inclusive and respectful environment.  Sports and other activites:  Sustainable transport:  Additional parking was provided for more sustainable transport modes like rental bikes, and travel to venues by public transport was encouraged.  2  9  A diverse programme of activites was offered to promote physical exercise, well-being and active lifestyles.  Visibility of diverse social projects:  Green electricity:  Fan zones were powered by certified green electricity from renewable sources, thereby minimising CO2 emissions and supporting climate protection.  1  10  Diverse and inclusive social projects were publicised in fan zones in order to celebrate diversity and facilitate discussions around social issues."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "GOOD GOVERNANCE  ACCOUNTABILITY  Ensure that internal governance and compliance rules are implemented  WHAT WE ACHIEVED  WHAT WE DID  100%  ACTIONS  We enforced sustainability governance rules at all stages of the tournament to ensure transparency and accountability. Every process was meticulously documented, allowing for comprehensive performance evaluations by both UEFA and its external auditors. Governance and compliance processes established and implemented  Appointment of venue sustainability managers  Central coordination from the Frankfurt headquarters  Remote support from the team in Nyon  Apply UEFA Event Sustainability Performance Evaluation System WHAT WE DID  ACTIONS  We established and implemented an external verification process for UEFA’s Event Sustainability Performance Evaluation, targeting the highest level of performance and enabling us to identify both our successes and areas for improvement. Application of the system to the entire event life cycle  Third-party verification  of venues appointed sustainability managers  Good governance rules applied  7  UEFA sustainability managers based at the Nyon headquarters were designated to work exclusively on the tournament  WHAT WE ACHIEVED  EURO 2024 achieved level 4 out of 4 in terms of sustainability performance according to a new UEFA framework for evaluating the sustainability performance of events  UEFA was able to demonstrate compliance with the Performance Evaluation System Criteria for 50 out of 53 criteria (94%) certified by DEKRA  UEFA EURO 2024 ESG Report 41"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IN FOCUS  EVALUATION BY A THIRD PARTY EURO 2024 aimed to set the global benchmark for sustainability in sports events, while also driving sustainable development across German and European societies. Sustainability was embedded as a core principle in the organisers’ approach, guiding every phase of the tournament’s planning and execution. To support this, UEFA introduced the Event Sustainability Performance Evaluation System, a transparent framework for assessing sustainability across the environmental, social and governance pillars. The system assess events on 53 sustainability criteria in order to classify them as reaching one of four performance levels: base, established, advanced and excellence. EURO 2024 was the first UEFA event to which this system was applied, and it achieved excellence, the highest level of performance. The results were validated by an external audit, reinforcing the tournament’s commitment to setting a new standard for sustainable sports events.  Event Sustainability Performance Evaluation System: Insights This evaluation system is designed to empower the football ecosystem by offering event organisers a clear framework to assess and improve their sustainability performance over time. Its flexible structure makes it suitable for events of any scale, from local tournaments to global championships.  3 criteria  50 criteria  failed  achieved  Developed through extensive consultation with both internal and external experts and grounded in UEFA’s best practices and OECD guidelines, the system provides an objective measure of sustainability performance. From the 2024/25 season onward, it will be applied to all UEFA events, fostering collaboration and innovation among host cities, partners and stakeholders. This initiative aims to create a lasting football legacy rooted in sustainability.  UEFA performed particularly well in the social and governance dimensions. In the environmental dimension, three criteria failed in the area of waste and water management. UEFA EURO 2024 ESG Report 42"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "EDUCATION  TRAINING AND KNOWLEDGE SHARING  Train staff and volunteers on event sustainability policies and practices  WHAT WE ACHIEVED  81%  of staff and volunteers completed the sustainability e-learning module  WHAT WE DID  ACTIONS  We conducted a range of sustainability training activities, including e-learning modules for staff, volunteers and selected suppliers, to ensure that everyone was well prepared. A comprehensive code of conduct was established, and all EURO 2024 headquarters staff were given CPR training.  Sustainability e-learning modules  Code of conduct  90%  of staff at the headquarters completed the CPR training  CPR training  Engage stakeholders around practices and lessons learned WHAT WE DID We actively participated in numerous sports conferences before and after UEFA EURO 2024 to share our insights and best practices from the tournament, fostering engagement with a wide range of stakeholders. These events served as platforms for open and transparent dialogue, allowing us to provide updates on key developments and maintain strong connections with all stakeholder groups. ACTIONS  Code of conduct in place  WHAT WE ACHIEVED  2,000+  people engaged with across more than 20 conferences  Attendance at conferences UEFA EURO 2024 ESG Report 43"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "COMMUNICATIONS  WHAT WE DID  ACTIONS  We have drawn up this comprehensive ESG report detailing our sustainability initiatives and achievements at EURO 2024.  Communicate the event’s sustainability focus and performance WHAT WE DID We actively communicated our sustainability efforts at the tournament to all stakeholders and assessed the campaign’s effectiveness through comprehensive media monitoring.  ACTIONS  ment  assess Post-event  EURO 2024 ESG Report is being published on 1 November 2024  ESG report  Active communication  MENTAL, ENVIRON ND SOCIAL AANCE GOVERN REPORT  Media monitoring  79  posts were published on social media and six articles were published on UEFA.com  17.3m  views of our sustainability campaigns on social media  WHAT WE ACHIEVED  Publish a post-event EURO 2024 ESG report  WHAT WE ACHIEVED  REPORTING AND COMMUNICATION  UEFA EURO 2024 ESG Report 44"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "COMMUNICATIONS  CAMPAIGNS  Roll out sustainability-focused campaign  WHAT WE ACHIEVED  WHAT WE DID  ACTIONS  We launched a targeted EURO 2024 communications campaign emphasising the core sustainability messages of inclusivity and environmental respect, in particular through the #FootbALL campaign and the 4R principles respectively. This campaign ran from mid-June to late July and included LED board advertising, social media posts and online articles. Communications campaign  5.4 bn  people reached by #FootbALL and 4R campaigns  REDUCE REUSE RECYCLE RECOVER  231  territories reached by our communication campaign People were reached through advertisements, LED and giant screen  UEFA EURO 2024 ESG Report 45"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IN FOCUS  PROMOTING ESG AT EURO 2024 A key aspect of the EURO 2024 ESG strategy was implementing a well-defined communications campaign to raise public awareness of our various programmes and activities.  Inspiring action through #FootbALL The #FootbALL campaign celebrating inclusivity and diversity in football was promoted throughout EURO 2024 through a 30-second television advertisement, LED boardings and big-screen announcements. It reached an average of more than 100 million spectators per matchday in more than 50 countries around the world. Ten #FootbALL posts were published on social media, generating nearly 500,000 views and 10,000 engagements.  Spreading the message on social media A comprehensive social media campaign promoting various aspects of sustainability was deployed throughout EURO 2024, helping to amplify the key messages to a global audience and inspire fans to adopt sustainable practices. A total of 79 posts were published during the tournament, amassing more than 17.3 million views.  Further insights on UEFA.com Reduce, reuse, recycle, recover The circular economy on matchdays is underpinned by the 4R principle – reduce, reuse, recycle, recover – which aims to reduce the amount of waste produced and maximise the product life cycles. LED boards at every EURO 2024 stadium displayed messages encouraging fans to reuse their cups and recycle correctly.  Starting in mid-June, a series of articles were published on UEFA. com to inform fans and stakeholders about sustainability efforts at EURO 2024. Ranging from an overview of the sustainability strategy to detailed post-tournament reports, these articles provided valuable insights into how UEFA’s initiatives were implemented and their effectiveness. Overall, six articles were published across the various ESG areas, generating 54,100 views in total."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ECONOMY  EVENT IMPACT  Publish a EURO 2024 impact study  WHAT WE ACHIEVED  WHAT WE DID UEFA published a tournament Summary in August 2024 that included a dedicated ESG section, highlighting initial data points gathered in this domain. For its part, also in August 2024, Nielsen Sports published an independent study highlighting the tournament’s positive economic and social impact on host country and host cities.  UEFA EURO 2024 Tournament Summary, published in August 2024  Host Country Impact Study, published by Nielsen Sports in August 2024  Evaluation Study of UEFA EURO 2024, to be published in November 2024  ACTIONS  Lastly, the German Federal Ministry of the Interior and Community (BMI) commissioned an evaluation study, led by Bielefeld University and the German Sport University Cologne, to evaluate the ecological, economic, and social sustainability of the tournament. UEFA EURO 2024 Tournament Summary  Data and topical inputs to Nielsen Sports for the publication of the Host Country Impact Study  Data and topical inputs to the Evaluation Study commissioned by the German Federal Ministry of the Interior and Community  UEFA EURO 2024 ESG Report 47"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Publisher Union of European Football Associations (UEFA) Executive Michele Uva, UEFA Social and Environmental Sustainability Director Report coordinator Serena Tigani, UEFA Social and Environmental Sustainability Specialist Report contributors Laetitia Cavin, Nicoletta Flutti, Iris Hugo-Bouvier, Sara Holmgren, Valentina Miotti, Presilia Mpanu-Mpanu, Monica Namy, Vincent Reulet, Nina Seibert, Tim Thormann, Josephine Thury, Filippo Veglio, Hugo Viseu Editorial, design and layout Touchline Enquiries or feedback: UEFA Social and Environmental Sustainability Division +41 848 00 27 27 | sustainability@uefa.ch Nyon, November 2024"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Route de Genève 46 CH-1260 Nyon 2 Switzerland sustainability@uefa.ch +41 848 00 27 27 uefa.com/sustainability"
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n\n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n\n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'addContentLink'\n        })\n      }\n\n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLinkThree'\n        })\n      }\n\n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n\n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function animateNumbers(klass, delay = 1000, stagger = 0.3) {\n        numbers = cOf(klass)\n\n        setTimeout(function() {\n          for (let i = 0; i < numbers.length; i++) {\n            setTimeout(animateNumber, stagger * 1000 * i, numbers[i])\n          }\n        }, delay * 1000)\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 60;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-3SLJZ23T3W" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "NXlJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P1S/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WAiT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "biBg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bp21":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "opfQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u/WO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x9Sl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6c3d6261fa3229383c86.js